import React, { useCallback, useEffect, useState } from 'react';

import Button from '../../components/Button/Button';
import alert from '../../helpers/alert';
import extractErrorMessage from '../../utils/extractErrorMessage';
import styles from './sheetSync.module.css';
import ProblemsTable from './ProblemsTable';
import { getSheetSyncState, runSheetSync, saveSheetLinks } from '../../api/prices';
import { KIND_LABELS, deltaText, formatDateTime, isBigJump, money } from './sheetSyncFormat';

const kindClass = (kind) =>
  [styles.kind, { created: styles.kindCreated, changed: styles.kindChanged, held: styles.kindHeld }[kind]]
    .filter(Boolean)
    .join(' ');

// Ð¢Ð°Ð±Ð»Ð¸ÑÐ° Â«Ð±ÑÐ»Ð¾ â ÑÑÐ°Ð»Ð¾ â ÑÐ°Ð·Ð½Ð¸ÑÐ°Â»: Ð¾Ð±ÑÐ¸Ð¹ Ð²Ð¸Ð´ Ð´Ð»Ñ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ð¹ Ð¸ Ð´Ð»Ñ Ð¶Ð´ÑÑÐ¸Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ
const DiffTable = ({ items, selectable, selected, onToggle }) => (
  <table className={styles.table}>
    <thead>
      <tr>
        {selectable && <th />}
        <th>Ð§ÑÐ¾</th>
        <th>ÐÐ°ÑÐºÐ°</th>
        <th className={styles.num}>ÐÑÐ»Ð¾</th>
        <th className={styles.num}>Ð¡ÑÐ°Ð»Ð¾</th>
        <th className={styles.num}>Ð Ð°Ð·Ð½Ð¸ÑÐ°</th>
        <th>ÐÑÐ¸Ð¼ÐµÑÐ°Ð½Ð¸Ðµ</th>
      </tr>
    </thead>
    <tbody>
      {items.map((i) => (
        <tr key={`${i.key}-${i.ruleId ?? 'new'}-${i.label}`}>
          {selectable && (
            <td>
              <input
                type="checkbox"
                aria-label={`ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ ${i.key}`}
                checked={selected.has(i.key)}
                onChange={() => onToggle(i.key)}
              />
            </td>
          )}
          <td>
            <span className={kindClass(i.kind)}>{KIND_LABELS[i.kind]}</span> <b>{i.key}</b> {i.label}
          </td>
          <td>{i.mark}</td>
          <td className={`${styles.num} ${styles.was}`}>{money(i.oldPrice)}</td>
          <td className={`${styles.num} ${styles.now}`}>{money(i.newPrice)}</td>
          <td className={`${styles.num} ${isBigJump(i.oldPrice, i.newPrice) ? styles.deltaBig : ''}`}>
            {deltaText(i.oldPrice, i.newPrice)}
          </td>
          <td className={styles.muted}>{i.note}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

// ÐÐºÐ»Ð°Ð´ÐºÐ° Â«Ð¢Ð°Ð±Ð»Ð¸ÑÐ°Â»: ÑÑÐ¾ ÑÐµÐ¹ÑÐ°Ñ Ñ Google-ÑÐ°Ð±Ð»Ð¸ÑÐµÐ¹ Ð¿ÑÐ¸ÐºÐ°Ð·Ð¾Ð² â Ðº Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ, Ð¶Ð´ÑÑ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ, Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ñ
const SheetSync = ({ marks = [], onProblemsCount }) => {
  const [state, setState] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [selected, setSelected] = useState(() => new Set());
  // ÐÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ Ð¼ÐµÐ½ÑÐµÑ ÑÐµÐ½Ñ ÑÑÐ¾ÐºÐ°: Ð¾Ð´Ð½Ð¾Ð³Ð¾ ÐºÐ»Ð¸ÐºÐ° Ð¼Ð°Ð»Ð¾, Ð²ÑÐ¾ÑÐ¾Ð¹ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÐµÑ (ÐºÐ°Ðº Ð½Ð° ÑÐºÑÐ°Ð½Ðµ Ð¿ÑÐ°Ð¹ÑÐ°)
  const [confirmKind, setConfirmKind] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setError('');
    getSheetSyncState()
      .then((res) => {
        setState(res.data);
        setSelected(new Set());
        setConfirmKind(null);
        onProblemsCount?.(res.data?.view?.problems?.length || 0);
      })
      .catch((err) => {
        setState(null);
        setError(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿ÑÐ¾ÑÐ¸ÑÐ°ÑÑ ÑÐ°Ð±Ð»Ð¸ÑÑ');
      })
      .finally(() => setLoading(false));
  }, [onProblemsCount]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (!confirmKind) return undefined;
    const timer = setTimeout(() => setConfirmKind(null), 6000);
    return () => clearTimeout(timer);
  }, [confirmKind]);

  const view = state?.view;
  const toggle = (key) =>
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });

  const run = async (kind, confirm = []) => {
    if (confirmKind !== kind) {
      setConfirmKind(kind);
      return;
    }
    setConfirmKind(null);
    setBusy(true);
    try {
      const res = await runSheetSync({ dryRun: false, confirm });
      const r = res.data.run;
      if (r.status === 'error') alert.error(r.message || 'ÐÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ Ð½Ðµ ÑÐ´Ð°Ð»Ð¾ÑÑ');
      else if (r.status === 'blocked') alert.error(r.message || 'Ð¢Ð°Ð±Ð»Ð¸ÑÐ° Ð¾ÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð° Ð¿ÑÐ¾Ð²ÐµÑÐºÐ°Ð¼Ð¸');
      else alert.success(`ÐÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¾: Ð½Ð¾Ð²ÑÑ Ð¿ÑÐ°Ð²Ð¸Ð» ${r.created}, Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¾ ${r.changed}. ÐÐ°Ð¿ÑÑÐº Ð·Ð°Ð¿Ð¸ÑÐ°Ð½ Ð²Ð¾ Ð²ÐºÐ»Ð°Ð´ÐºÐµ Â«ÐÑÑÐ¾ÑÐ¸ÑÂ».`);
      load();
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ ÑÐ°Ð±Ð»Ð¸ÑÑ');
    } finally {
      setBusy(false);
    }
  };

  const saveLinks = async (links, okText) => {
    setBusy(true);
    try {
      const res = await saveSheetLinks(links);
      if (res.data.errors?.length) {
        alert.error(res.data.errors.join('; '));
        return;
      }
      alert.success(okText);
      load();
    } catch (err) {
      alert.error(extractErrorMessage(err) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ');
    } finally {
      setBusy(false);
    }
  };

  if (loading && !state) return <div className={styles.empty}>Ð§Ð¸ÑÐ°Ñ ÑÐ°Ð±Ð»Ð¸ÑÑâ¦</div>;
  if (error)
    return (
      <>
        <div className={`${styles.banner} ${styles.bannerBad}`}>{error}</div>
        <Button text="ÐÐ¾Ð²ÑÐ¾ÑÐ¸ÑÑ" onClick={load} />
      </>
    );
  if (!view) return null;

  const problems = view.problems || [];
  const held = view.held || [];
  const changes = view.changes || [];

  return (
    <>
      <div className={styles.top}>
        {/* Button Ð½Ðµ Ð¿ÑÐ¾Ð±ÑÐ°ÑÑÐ²Ð°ÐµÑ title, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ° â Ð½Ð° Ð¾Ð±ÑÑÑÐºÐµ */}
        <span title="ÐÐ°Ð½Ð¾Ð²Ð¾ Ð¿ÑÐ¾ÑÐ¸ÑÐ°ÑÑ Google-ÑÐ°Ð±Ð»Ð¸ÑÑ Ð¸ Ð¿ÐµÑÐµÑÑÐ¸ÑÐ°ÑÑ ÑÐºÑÐ°Ð½. ÐÐ¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð·Ð°Ð¿Ð¸ÑÑÐ²Ð°ÐµÑ.">
          <Button text="ÐÑÐ¾Ð²ÐµÑÐ¸ÑÑ ÑÐ°Ð±Ð»Ð¸ÑÑ" onClick={load} disabled={busy || loading} />
        </span>
        <span title="ÐÐ°Ð¿Ð¸ÑÐ°ÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¸Ð· ÑÐ°Ð·Ð´ÐµÐ»Ð° Â«Ð Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ» Ð¸ Ð¿ÑÐ¸Ð²ÐµÑÑÐ¸ ÑÐµÐ½Ñ Ð¼Ð°ÑÐ¸Ð½ Ð² Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ Ðº Ð¿ÑÐ¸ÐºÐ°Ð·Ð°Ð¼. ÐÐ°Ð¶Ð¸Ð¼Ð°ÐµÑÑÑ Ð´Ð²Ð°Ð¶Ð´Ñ.">
          <Button
            text={confirmKind === 'apply' ? `ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ ${changes.length}? Ð­ÑÐ¾ Ð¸Ð·Ð¼ÐµÐ½Ð¸Ñ ÑÐµÐ½Ñ ÑÑÐ¾ÐºÐ°` : `ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ: ${changes.length}`}
            onClick={() => run('apply')}
            disabled={busy || loading || changes.length === 0 || !!view.blocked}
            fill
            style={confirmKind === 'apply' ? { borderColor: '#d84a4a', color: '#d84a4a' } : {}}
          />
        </span>
        <span className={`${styles.grow} ${styles.muted}`}>
          {state.lastRun ? `ÐÐ¾ÑÐ»ÐµÐ´Ð½Ð¸Ð¹ Ð·Ð°Ð¿ÑÑÐº: ${formatDateTime(state.lastRun.startedAt)}` : 'ÐÐ°Ð¿ÑÑÐºÐ¾Ð² ÐµÑÑ Ð½Ðµ Ð±ÑÐ»Ð¾'}
          {state.enabled ? ' Â· Ð°Ð²ÑÐ¾Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð²ÐºÐ»ÑÑÐµÐ½Ð°' : ' Â· Ð°Ð²ÑÐ¾Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð²ÑÐºÐ»ÑÑÐµÐ½Ð°: ÑÐµÐ½Ñ Ð¼ÐµÐ½ÑÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹'}
        </span>
      </div>

      <details className={styles.help}>
        <summary>Ð§ÑÐ¾ Ð´ÐµÐ»Ð°ÑÑ ÐºÐ½Ð¾Ð¿ÐºÐ¸ Ð½Ð° ÑÑÐ¾Ð¼ ÑÐºÑÐ°Ð½Ðµ</summary>
        <ul>
          <li>
            <b>ÐÑÐ¾Ð²ÐµÑÐ¸ÑÑ ÑÐ°Ð±Ð»Ð¸ÑÑ</b> â Ð·Ð°Ð½Ð¾Ð²Ð¾ ÑÐ¸ÑÐ°ÐµÑ Google-ÑÐ°Ð±Ð»Ð¸ÑÑ Ð¸ Ð¿ÐµÑÐµÑÑÐ¸ÑÑÐ²Ð°ÐµÑ ÑÐºÑÐ°Ð½. ÐÐ¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð·Ð°Ð¿Ð¸ÑÑÐ²Ð°ÐµÑ.
          </li>
          <li>
            <b>ÐÑÐ¸Ð²ÑÐ·Ð°ÑÑ</b> (Ñ Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ð½Ð¾Ð¹ ÑÑÑÐ¾ÐºÐ¸) â ÑÐ¾ÑÑÐ°Ð½ÑÐµÑ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÑ ÑÑÐ°Ð·Ñ, Ð²ÑÐ¾ÑÐ¾Ð¹ ÐºÐ½Ð¾Ð¿ÐºÐ¸ Â«Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑÂ» Ð½ÐµÑ. ÐÑÐ¸Ð²ÑÐ·ÐºÐ° ÑÐ¾Ð»ÑÐºÐ¾
            Ð³Ð¾Ð²Ð¾ÑÐ¸Ñ ÑÐ¸ÑÑÐµÐ¼Ðµ, Ðº ÐºÐ°ÐºÐ¾Ð¼Ñ Ð¿ÑÐ°Ð²Ð¸Ð»Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð° Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ ÑÑÑÐ¾ÐºÐ°. Ð¦ÐµÐ½Ñ Ð¾Ð½Ð° Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑ: ÐµÑÐ»Ð¸ ÑÐµÐ½Ð° Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ Ð¾ÑÐ»Ð¸ÑÐ°ÐµÑÑÑ Ð¾Ñ ÑÐµÐ½Ñ
            Ð¿ÑÐ°Ð²Ð¸Ð»Ð°, ÑÐ°Ð·Ð½Ð¸ÑÐ° Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð² Â«Ð Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ».
          </li>
          <li>
            <b>ÐÑÐ±ÑÐ°ÑÑ Ð²ÑÑÑÐ½ÑÑ</b> â ÑÐºÐ°Ð·Ð°ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ, ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ, Ð³Ð¾Ð´, Ð¾Ð±ÑÑÐ¼ Ð¸ Ð¿ÑÐ¸Ð²Ð¾Ð´ ÑÐ°Ð¼Ð¾Ð¼Ñ, ÐµÑÐ»Ð¸ Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ¸ Ð½Ðµ Ð¿Ð¾Ð´Ð¾ÑÐ»Ð¸.
          </li>
          <li>
            <b>ÐÐµ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÐ¾Ð²Ð°ÑÑ</b> â Ð¸ÑÐºÐ»ÑÑÐ¸ÑÑ ÑÑÑÐ¾ÐºÑ Ð¸Ð· ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸. ÐÐµÑÐ½ÑÑÑ ÐµÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð½Ð° Ð²ÐºÐ»Ð°Ð´ÐºÐµ Â«ÐÑÐ¸Ð²ÑÐ·ÐºÐ¸Â».
          </li>
          <li>
            <b>ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ</b> â ÐµÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½Ð°Ñ ÐºÐ½Ð¾Ð¿ÐºÐ°, ÐºÐ¾ÑÐ¾ÑÐ°Ñ Ð¼ÐµÐ½ÑÐµÑ ÑÐµÐ½Ñ: Ð·Ð°Ð¿Ð¸ÑÑÐ²Ð°ÐµÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¸Ð· Â«Ð Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ» Ð¸
            Ð¿ÑÐ¸Ð²Ð¾Ð´Ð¸Ñ ÑÐµÐ½Ñ Ð¼Ð°ÑÐ¸Ð½ Ð² Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ Ðº Ð¿ÑÐ¸ÐºÐ°Ð·Ð°Ð¼. ÐÐ°Ð¶Ð¸Ð¼Ð°ÐµÑÑÑ Ð´Ð²Ð°Ð¶Ð´Ñ, Ð¾ÑÐºÐ°Ñ â Ð²ÐºÐ»Ð°Ð´ÐºÐ° Â«ÐÑÑÐ¾ÑÐ¸ÑÂ».
          </li>
          <li>ÐÑÐµ ÑÐ¶Ðµ Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½Ð½ÑÐµ ÑÑÑÐ¾ÐºÐ¸ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ, Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑ Ð¸Ð»Ð¸ Ð¾ÑÐ²ÑÐ·Ð°ÑÑ Ð½Ð° Ð²ÐºÐ»Ð°Ð´ÐºÐµ Â«ÐÑÐ¸Ð²ÑÐ·ÐºÐ¸Â».</li>
        </ul>
      </details>

      {view.blocked && <div className={`${styles.banner} ${styles.bannerBad}`}>Ð¢Ð°Ð±Ð»Ð¸ÑÐ° Ð¾ÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð°: {view.blocked}</div>}

      <div className={styles.stats}>
        <div className={styles.stat}>
          <span>ÑÑÑÐ¾Ðº Ð² ÑÐ°Ð±Ð»Ð¸ÑÐµ</span>
          <b>{view.rows}</b>
        </div>
        <div className={styles.stat}>
          <span>ÑÐ¾Ð²Ð¿Ð°Ð»Ð¾ Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð¾Ð¼</span>
          <b className={styles.ok}>{view.same}</b>
        </div>
        <div className={styles.stat}>
          <span>Ðº Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ</span>
          <b>{changes.length}</b>
        </div>
        <div className={styles.stat}>
          <span>Ð¶Ð´ÑÑ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ</span>
          <b className={held.length ? styles.warn : ''}>{held.length}</b>
        </div>
        <div className={styles.stat}>
          <span>Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ñ</span>
          <b className={problems.length ? styles.bad : ''}>{problems.length}</b>
        </div>
        <div className={styles.stat}>
          <span>Ð½Ðµ ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÑÑÑÑÑ</span>
          <b>{view.ignored}</b>
        </div>
      </div>

      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>
          ÐÑÐ¾Ð±Ð»ÐµÐ¼Ñ <span className={styles.count}>{problems.length}</span>
        </h3>
        <div className={styles.hint}>
          Ð­ÑÐ¸ ÑÑÑÐ¾ÐºÐ¸ Google-ÑÐ°Ð±Ð»Ð¸ÑÑ ÑÐ¸ÑÑÐµÐ¼Ð° Ð½Ðµ ÑÐ¼Ð¾Ð³Ð»Ð° ÑÐ°Ð¼Ð° ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð¸ÑÑ Ñ Ð½Ð°ÑÐ¸Ð¼Ð¸ Ð´Ð°Ð½Ð½ÑÐ¼Ð¸ (Ð¼Ð¾Ð´ÐµÐ»ÑÑ Ð¸ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸ÐµÐ¹ Ð² Ð¿ÑÐ¸ÐºÐ°Ð·Ðµ). ÐÐ»Ñ ÐºÐ°Ð¶Ð´Ð¾Ð¹ Ð²ÑÐ±ÐµÑÐ¸ÑÐµ,
          ÐºÐ°ÐºÐ¾Ð¹ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ð¸ Ð¿ÑÐ¸ÐºÐ°Ð·Ð° Ð¾Ð½Ð° ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²ÑÐµÑ, Ð¸ Ð½Ð°Ð¶Ð¼Ð¸ÑÐµ Â«ÐÑÐ¸Ð²ÑÐ·Ð°ÑÑÂ», Ð»Ð¸Ð±Ð¾ Ð¸ÑÐºÐ»ÑÑÐ¸ÑÐµ ÑÑÑÐ¾ÐºÑ. ÐÑÐ¸Ð²ÑÐ·ÐºÐ° ÑÐ¾ÑÑÐ°Ð½ÑÐµÑÑÑ ÑÑÐ°Ð·Ñ Ð¸ ÑÐµÐ½Ñ Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑ: ÐµÑÐ»Ð¸ ÑÐµÐ½Ð° Ð²
          ÑÐ°Ð±Ð»Ð¸ÑÐµ Ð´ÑÑÐ³Ð°Ñ, ÑÐ°Ð·Ð½Ð¸ÑÐ° Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ Ð² Â«Ð Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ». ÐÐ¾ÐºÐ° ÑÑÑÐ¾ÐºÐ° Ð½Ðµ ÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð°, ÐµÑ ÑÐµÐ½Ð° Ð² Ð¿ÑÐ°Ð¹Ñ Ð½Ðµ Ð¿Ð¾Ð¿Ð°Ð´Ð°ÐµÑ.
        </div>
        <ProblemsTable
          problems={problems}
          marks={marks}
          busy={busy}
          onLink={(links, okText) => saveLinks(links, okText)}
          onIgnore={(key) =>
            saveLinks([{ sheetKey: key, ignore: true }], `${key} Ð¸ÑÐºÐ»ÑÑÐµÐ½Ð° Ð¸Ð· ÑÐ¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð°ÑÐ¸Ð¸. ÐÐµÑÐ½ÑÑÑ ÐµÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð½Ð° Ð²ÐºÐ»Ð°Ð´ÐºÐµ Â«ÐÑÐ¸Ð²ÑÐ·ÐºÐ¸Â».`)
          }
        />
      </section>

      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>
          ÐÐ´ÑÑ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ñ <span className={styles.count}>{held.length}</span>
        </h3>
        <div className={styles.hint}>
          Ð¡ÐºÐ°ÑÐ¾Ðº ÑÐµÐ½Ñ Ð±Ð¾Ð»ÑÑÐµ 10 % Ð¸Ð»Ð¸ Ð¿ÐµÑÐ²Ð°Ñ ÑÐµÐ½Ð° Ñ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð±ÐµÐ· Ð¿ÑÐ°Ð²Ð¸Ð». ÐÑÐ¼ÐµÑÑÑÐµ ÑÐ¾, ÑÑÐ¾ Ð²ÐµÑÐ½Ð¾, Ð¸ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÐµ: ÑÑÐ¾ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸Ñ
          Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ðµ Ð²Ð¼ÐµÑÑÐµ Ñ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐ¼Ð¸ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÐ¼Ð¸.
        </div>
        {held.length === 0 ? (
          <div className={styles.empty}>ÐÐ¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¶Ð´ÑÑ</div>
        ) : (
          <>
            <DiffTable items={held} selectable selected={selected} onToggle={toggle} />
            <div className={styles.rowActions}>
              <Button
                text={confirmKind === 'held' ? `ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ ${selected.size} Ð¸ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ?` : 'ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐµ Ð¸ Ð¿ÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ'}
                onClick={() => run('held', [...selected])}
                disabled={busy || selected.size === 0}
                style={confirmKind === 'held' ? { borderColor: '#d84a4a', color: '#d84a4a' } : {}}
              />
            </div>
          </>
        )}
      </section>

      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>
          Ð Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ <span className={styles.count}>{changes.length}</span>
        </h3>
        <div className={styles.hint}>
          ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ, Ð¿ÑÐ¾ÑÐµÐ´ÑÐ¸Ðµ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸. ÐÐ½Ð¾Ð¿ÐºÐ° Â«ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸ÑÂ» Ð·Ð°Ð¿Ð¸ÑÐµÑ ÑÑÐ¸ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð¸ Ð¿ÑÐ¸Ð²ÐµÐ´ÑÑ ÑÐµÐ½Ñ ÑÑÐ¾ÐºÐ° Ðº Ð¿ÑÐ¸ÐºÐ°Ð·Ð°Ð¼.
        </div>
        {changes.length === 0 ? <div className={styles.empty}>Ð¢Ð°Ð±Ð»Ð¸ÑÐ° ÑÐ¾Ð²Ð¿Ð°Ð´Ð°ÐµÑ Ñ Ð¿ÑÐ¸ÐºÐ°Ð·Ð¾Ð¼</div> : <DiffTable items={changes} />}
      </section>
    </>
  );
};

export default SheetSync;
